import { render, staticRenderFns } from "./SideBarChat.vue?vue&type=template&id=27117a6e&"
import script from "./SideBarChat.vue?vue&type=script&lang=js&"
export * from "./SideBarChat.vue?vue&type=script&lang=js&"
import style0 from "./SideBarChat.vue?vue&type=style&index=0&id=27117a6e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports